// extracted by mini-css-extract-plugin
export default {"container":"sparkles_container__3lQ+8","animate":"sparkles_animate__hvM0e"};